import { LoadingPlaceholder } from '@/common/components/LoadingPlaceholder/LoadingPlaceholder';
import { PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { useGetFlexibleBenefitsSummary } from '@/common/integrations/menhir/employee/flexible-benefits/flexible-benefits.hooks';
import { ESMealHomePage } from './ESMealHomePage';
import { ESWalletHomePage } from './ESWalletHomePage';

export function ESHomePage() {
  const { company } = useEmployeeDetails();
  const { error, isInitialLoading } = useGetFlexibleBenefitsSummary();

  if (isInitialLoading) {
    return <LoadingPlaceholder />;
  }

  if (company.settings?.plan === PLAN.ES_MEAL || error?.statusCode === 404) {
    return <ESMealHomePage />;
  }

  if (error) {
    throw error;
  }

  if (
    company.settings?.plan === PLAN.ES_WALLET ||
    company.settings?.plan === PLAN.ES_HYBRID
  ) {
    return <ESWalletHomePage />;
  }
}
